'use strict';
const angular = require('angular');

/*@ngInject*/
export function WebAccessService($resource) {
  return $resource('/api/webaccess/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/webaccess/:id/attachments"
    },
    getByContact: {
      method: 'GET',
      url: "/api/webaccess/by-contact/:contactId",
      isArray: true
    },
    resetPassword: {
      method: 'PUT',
      url: "/api/webaccess/reset-password/:id",
    },
    sendInvitations: {
      method: 'POST',
      url: "/api/webaccess/send-invitations"
    }
  });
}


export default angular.module('conduu.WebAccessService', [])
  .factory('WebAccessService', WebAccessService)
  .name;



// WEBPACK FOOTER //
// ./client/components/webaccess/webaccess.service.js